import React from 'react';
import { fetchLegacyProps } from '../../utils/config';
import Header from '../../components/Header';
/**
 * This component is rendered on every page in the header,
 * and is therefore not directly a page in itself,
 * but also neither just a "component".
 * */
var HeaderPartial = function () {
    var _a = fetchLegacyProps(), _b = _a.is_landing_page, isWelcomePage = _b === void 0 ? false : _b, _c = _a.is_logged_in, isLoggedIn = _c === void 0 ? false : _c;
    return React.createElement(Header, { isLoggedIn: isLoggedIn, isWelcomePage: isWelcomePage });
};
export default HeaderPartial;
